
<div class="d-flex flex-column">
  <form *ngIf="myFormGroup" [formGroup]="myFormGroup" (ngSubmit)="onCommitResponses()">
    <ng-template #dferror>
      <div class="alert alert-danger">{{"DCO.DynamicForm_Error" |translate }}</div>
    </ng-template>
    <div id="DynamicForm" *ngIf="dfError == false; else dferror">
      <h6 class="text-primary" *ngIf="loadCompleted == true">{{ "DCO.DynamicForm_"+dynamicForm?.tittle+"_title" | translate }}</h6>
      <div class="row">
        <div class="col-12">
          <div *ngIf="loadCompleted == false" class="d-flex justify-content-center"
            style="position: absolute; left: 50%">
            <div class="spinner-border spinner-border-smtext-customer"></div>
          </div>
          <div class="table-responsive">
            <table class="table table-borderless order-table">
              <thead>
                <tr hidden><th colspan="2"></th></tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let sectionDisp of dynamicForm?.sectionsDisposition">
                  <ng-container *ngFor="
                        let questionDisp of sectionDisp.section.questionsDisposition
                      ">
                    <!-- <tr *ngIf="(questionDisp.question.visible && !questionDisp.question.rfv_RequiredFieldValidatorControl) || showHiddenFields"> -->
                    <tr *ngIf="isVisible(questionDisp.questionId) && !isDocumentRequiredControl(questionDisp.question.lbl_LabelText)">
                      <td class="w-25 text-end"
                        [attr.colspan]="questionDisp.question.controlTypeName == 'Questions_Header' || questionDisp.question.controlTypeName =='Questions_Label'?2:1">
                        <span class="form-label fw-semibold">{{ questionDisp.question.lbl_LabelText | translate}}</span></td>
                      <td class="w-75">
                        <ng-container [ngSwitch]="getControlTypeCached(questionDisp).type">
                          <!-- Input Field -->
                          <ng-container *ngSwitchCase="'input'">
                            <input name="{{questionDisp.questionId}}" formControlName="{{questionDisp.questionId}}"
                              [type]="getControlTypeCached(questionDisp).inputType" class="form-control"
                              [attr.placeholder]="questionDisp.question.defaultValue" />
                          </ng-container>
                          <!-- DropdownList and Dynamic Dropdown-->
                          <ng-container *ngSwitchCase="'dropdown'">
                            <select name="{{questionDisp.questionId}}" formControlName="{{questionDisp.questionId}}"
                              class="form-select" [attr.placeholder]="''">
                              <option disabled> {{ "DCO.DynamicForm_PleaseSelect" | translate}} </option>
                              <option *ngFor="let result of getControlTypeOptionsCached(questionDisp)"
                                [value]="result.value">
                                {{ result.text |translate }}
                              </option>
                            </select>
                          </ng-container>
                        </ng-container>
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div *ngIf="showErrorConfirm">
        <div class="mt-3 alert alert-danger" *ngFor="let error of listErrorConfirm">
          {{error}}
        </div>
      </div>
    </div>
  </form>
</div>



<!-- MODAL FALTAN DOCUMENTOS -->
<div
  class="modal fade"
  id="missingFilesGoOn"
  data-bs-backdrop="false"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-hidden="true"
  style="z-index: 99999;">

  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">

      <div class="modal-body text-center d-flex flex-column">

        <div class="flex-grow-1 d-flex flex-column justify-content-center align-items-center">

          <i class="fas fa-question-circle fa-3x text-info mb-3"></i>

          <h6 class="text-danger fw-semibold mb-0">
            {{ "DCO.MassiveInformation_DocumentsRequiredGoOn" | translate }}
            {{ "DCO.MassiveInformation_DocumentsRequiredGoOn1" | translate }}
          </h6>

        </div>

        <div class="d-flex justify-content-center gap-2 mt-4">

          <button
            type="button"
            class="btn btn-danger"
            data-bs-dismiss="modal">
            {{ "DCO.MassiveInformation_Cancel" | translate }}
          </button>

          <button
            type="button"
            class="btn btn-primary"
            data-bs-dismiss="modal"
            (click)="onCommitResponses(true)">
            {{ "DCO.Enrollment_Continue" | translate }}
          </button>

        </div>

      </div>

    </div>
  </div>
</div>

